var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BaseLobby } from '../../base-lobby';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { Router } from 'aurelia-router';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { I18N } from 'aurelia-i18n';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { ConfigClientService } from '../../../../../services/modules/client-config.service';
import { RoutingHelper } from '../../../../../helpers/routing.helper';
import { BindingSignaler } from 'aurelia-templating-resources';
var Lobby = /** @class */ (function (_super) {
    __extends(Lobby, _super);
    function Lobby(lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClientService, configClientService, routingHelper, bindingSignaler) {
        var _this = _super.call(this, lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClientService, configClientService, routingHelper, bindingSignaler) || this;
        _this.happyBirthdayImage = __CDN_IMAGES__ + "/graphics/game-happy-birthday.png";
        _this.luckyNumbersImage = __CDN_IMAGES__ + "/graphics/game-lucky-numbers.png";
        return _this;
    }
    Lobby.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showStories = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "lotteries-stories-closing-text",
                //Colors
                "lotteries-stories-jackpot-foreground",
                "lotteries-stories-closing-background",
                "lotteries-stories-closing-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showCarousel = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "carousel-lotteries-lottery-footer-button",
                //Colors
                "carousel-lotteries-arrow-icon-background",
                "carousel-lotteries-arrow-icon-foreground",
                "carousel-lotteries-lottery-content-background",
                "carousel-lotteries-lottery-content-name-foreground",
                "carousel-lotteries-lottery-content-country-foreground",
                "carousel-lotteries-lottery-content-prize-foreground",
                "carousel-lotteries-lottery-content-next-draw-foreground",
                "carousel-lotteries-lottery-footer-background",
                "carousel-lotteries-lottery-footer-button-foreground",
                "carousel-lotteries-lottery-footer-button-hover-foreground",
                "carousel-lotteries-lottery-footer-button-background",
                "carousel-lotteries-lottery-footer-button-hover-background"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                "template-background-xs",
                "template-background-sm",
                "template-background-lg",
                //Text
                "navigation-nav-home",
                "navigation-nav-latest-results",
                "navigation-nav-my-purchases",
                "navigation-nav-agent-winning-claims",
                "navigation-nav-cart",
                "lobby-play-button",
                //Colors
                "template-background",
                "header-background",
                "header-navigation-nav-foreground",
                "header-navigation-nav-hover-foreground",
                "header-navigation-nav-selected-foreground",
                "header-navigation-nav-background",
                "header-navigation-nav-hover-background",
                "header-navigation-nav-selected-background",
                "header-navigation-fab-cart-foreground",
                "header-navigation-fab-cart-background",
                "header-purchase-count-background",
                "header-purchase-count-foreground",
                "header-cart-count-background",
                "header-cart-count-foreground",
                "lotteries-lottery-card-background",
                "lotteries-lottery-card-shadow",
                "lotteries-lottery-card-title",
                "lotteries-lottery-card-date-foreground",
                "lotteries-lottery-card-content-background",
                "lotteries-lottery-button-foreground",
                "lotteries-lottery-button-hover-foreground",
                "lotteries-lottery-button-background",
                "lotteries-lottery-button-hover-background",
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showBundles = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "bundles-title",
                "bundles-no-of-lotteries",
                "bundles-play-now",
                //Colors
                "bundles-title-foreground",
                "bundles-background",
                "bundles-foreground",
                "bundles-button-background",
                "bundles-button-foreground",
                "bundles-button-background-hover",
                "bundles-show-more-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showInstantGames = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "instant-games-title",
                "instant-games-play-now",
                //Colors
                "instant-games-title-foreground",
                "instant-games-background",
                "instant-games-button-background",
                "instant-games-button-background-hover",
                "instant-games-button-foreground",
                "instant-games-button-foreground-hover"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showLatestResultsHowToPlay = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "latest-results-title",
                "latest-results-all-results",
                "latest-results-button",
                "how-to-play-title",
                //Colors
                "latest-results-title-foreground",
                "latest-results-all-results-foreground",
                "latest-results-name-foreground",
                "latest-results-date-foreground",
                "latest-results-num-background",
                "latest-results-num-border",
                "latest-results-num-foreground",
                "latest-results-num-bonus-background",
                "latest-results-num-bonus-foreground",
                "latest-results-button-foreground",
                "latest-results-button-hover-foreground",
                "latest-results-button-background",
                "latest-results-button-hover-background",
                "how-to-play-title-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lobby = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router, TokenClient, I18N, NotificationClientService,
            DialogClientService, ConfigClientService, RoutingHelper, BindingSignaler])
    ], Lobby);
    return Lobby;
}(BaseLobby));
export { Lobby };
